// extracted by mini-css-extract-plugin
module.exports = {"book-contact":"y_cj","bookContact":"y_cj","book-contact-icon":"y_ck","bookContactIcon":"y_ck","book-contact-link":"y_cl","bookContactLink":"y_cl"};